import Mustache from 'mustache'
import MESSAGES from 'core/data-model/constants/bi-messages'
import { formatNumber } from 'core/service/lib/number-format'

import { wrapWordingToTextJustify } from 'core/service/benefit-illustration/utils/wording-wrapper'

const TaxGioRetirementDeductionBenefit = ({ taxDeduction }) => {
  return (
    <div id="tax-benefit" className="legal group retirement-tax-benefit">
      <h3>{MESSAGES.TAX_DEDUCTION_BENEFIT_TITLE}</h3>
      <div className="disclaimer">
        <div>{MESSAGES.TAX_DEDUCTION_BENEFIT_SUB_TITLE}</div>
        <div
          dangerouslySetInnerHTML={{
            __html: `${MESSAGES.TAX_DEDUCTION_BENEFIT_SUB_DESCRIPTION} <strong>${wrapWordingToTextJustify(
              MESSAGES.GIO_TAX_DEDUCTION_BENEFIT_SUB_DESCRIPTION_STRONG
            )}</strong>`,
          }}
        />
        <ul className="taxdeduction">
          <li>
            <div>{MESSAGES.RETIREMENT_TAX_BENEFIT_SUB_LIST[0].description}</div>
            <div>
              {Mustache.render(MESSAGES.RETIREMENT_TAX_BENEFIT_SUB_LIST[0].benefit, {
                value:
                  taxDeduction.taxDeductionRetirementForYear === 0
                    ? '-'
                    : formatNumber(taxDeduction.taxDeductionRetirementForYear, 2, true),
              })}
            </div>
          </li>
        </ul>
        <p
          dangerouslySetInnerHTML={{
            __html: wrapWordingToTextJustify(
              MESSAGES.TAX_GIO_RETIREMENT_DEDUCTION_BENEFIT_SUB_ADDITIONAL.replace(/\n/g, '')
            ),
          }}
        ></p>
        <br />
        <p>{MESSAGES.NOTE}:</p>
        <ul>
          <li>
            <strong>{MESSAGES.RETIREMENT_TAX_CONSENT_BENEFIT_SUB_NOTES[0][0]}</strong>{' '}
            {MESSAGES.RETIREMENT_TAX_CONSENT_BENEFIT_SUB_NOTES[0][1]}
          </li>
        </ul>
      </div>
    </div>
  )
}

export default TaxGioRetirementDeductionBenefit
